import React, { Component } from 'react';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxAnnee extends Component {

    static defaultProps = {
        label: "Année",
        placeholder: "Année",
        start: 2015,
    };


    render = () => {

        const { start } = this.props;
        const fetchMethod = () => new Promise((resolve, reject) => {
            let years = [];
            for (var i = start; i <= new Date().getFullYear(); i++)
                years.push(i);
            resolve({ codeRetour: 0, reponseAPIobjet: years });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemKey={item => item}
            itemText={item => item}
        />;

    };

};